import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import React, { Fragment } from 'react';
import CustomLoader from 'components/CustomLoader';
import { EndorsementsTable } from '../components/EndorsementsTable';
import styles from '../styles.module.scss';

export function AddDriver({
  validation,
  endorsements,
  changes,
  loading,
  setEndorsements,
  setStage,
  submit,
  submitting,
  resetModal,
  stateOptions
}) {
  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Add a Driver
      </div>
      <div className={styles.line} />
      <Formik
        validationSchema={validation}
        initialValues={{
          first_name: '',
          last_name: '',
          date_of_birth: '',
          date_of_hire: '',
          years_of_experience: '',
          license_number: '',
          license_state: '',
          violations: 0,
          accidents: 0,
        }}
      >
        {({
          errors,
          touched,
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          validateForm,
          setTouched,
        }) => (
          <Fragment>
            <Form
              className={styles.form}
              onSubmit={handleSubmit}
              style={{ marginTop: 10 }}
            >
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="first_name"
                  type="text"
                  label="First Name"
                  placeholder="First Name"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.first_name}
                  touched={touched.first_name}
                  required
                />
                <FieldInput
                  id="last_name"
                  type="text"
                  label="Last Name"
                  placeholder="Last Name"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.last_name}
                  touched={touched.last_name}
                  required
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="date_of_birth"
                  type="date"
                  label="Date of Birth"
                  placeholder="Date of Birth"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.date_of_birth}
                  touched={touched.date_of_birth}
                />
                <FieldInput
                  id="date_of_hire"
                  type="date"
                  label="Date of Hire"
                  placeholder="Date of Hire"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.date_of_hire}
                  touched={touched.date_of_hire}
                  required
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="years_of_experience"
                  type="number"
                  label="Years of Experience"
                  placeholder="Years of Experience"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.years_of_experience}
                  touched={touched.years_of_experience}
                  required
                />
                <FieldInput
                  id="license_number"
                  type="text"
                  label="License Number"
                  placeholder="License Number"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.license_number}
                  touched={touched.license_number}
                  required
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="license_state"
                  type="select"
                  label="License State"
                  placeholder="License State"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.license_state}
                  touched={touched.license_state}
                  options={stateOptions}
                />
                <FieldInput
                  id="violations"
                  type="number"
                  label="Number of Violations"
                  placeholder="Number of Violations"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.violations}
                  touched={touched.violations}
                  required
                  min={0}
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="accidents"
                  type="number"
                  label="Number of Accidents"
                  placeholder="Number of Accidents"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.accidents}
                  touched={touched.accidents}
                  required
                  min={0}
                />
              </div>
            </Form>
            {endorsements.length > 0 && (
              <EndorsementsTable changes={changes} loading={loading} />
            )}
            <div
              className={styles.footer}
              style={{
                justifyContent: 'space-between',
              }}
            >
              <div className={styles.buttons}>
                <button
                  className={styles.cancel}
                  onClick={resetModal}
                >
                  Cancel
                </button>
              </div>
              <div className={styles.buttons}>
                <button
                  className={styles.save}
                  style={{
                    marginRight: 10,
                    marginLeft: 10,
                    width: '240px',
                  }}
                  onClick={async () => {
                    const hasEnteredData = values.first_name ||
                      values.last_name ||
                      values.date_of_hire ||
                      values.years_of_experience ||
                      values.license_number ||
                      values.violations ||
                      values.accidents;

                    if (hasEnteredData) {
                      setTouched({
                        first_name: true,
                        last_name: true,
                        date_of_hire: true,
                        years_of_experience: true,
                        license_number: true,
                        violations: true,
                        accidents: true,
                      });

                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        setEndorsements((prev) => [
                          ...prev,
                          {
                            type: 'add_driver',
                            value: values,
                          },
                        ]);

                        setStage('select_endorsement_type');
                      }
                    } else {
                        setStage('select_endorsement_type');
                      }
                  }}
                >
                  Add Another Change
                </button>
                <button
                  className={styles.save}
                  style={{ width: '330px' }}
                  onClick={async () => {
                    setTouched({
                      first_name: true,
                      last_name: true,
                      date_of_hire: true,
                      years_of_experience: true,
                      license_number: true,
                      violations: true,
                      accidents: true,
                    });

                    const validation = await validateForm(values);

                    if (Object.values(validation).length === 0) {
                      submit([
                        ...endorsements,
                        {
                          type: 'add_driver',
                          value: values,
                        },
                      ]);
                    }
                  }}
                >
                  {submitting ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    'Finish and Submit Endorsement'
                  )}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </Formik>
    </div>
  );
}
